import React from "react";
import SurveyContainer from "../containers/SurveyContainer";

export const SurveyPage: React.FunctionComponent = () => <SurveyContainer />;